<template>
    <va-edit-layout>
        <ShipmentEventShipmentItemCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></ShipmentEventShipmentItemCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
